import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import "./i18n";
import store from "./store";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "./appstyle.css";
import "./responsive.css";
import ReduxToastr from "react-redux-toastr";
import { authCheck, adminauthCheck } from "./store/reducers/auth";
import { stopLoader } from "./store/reducers/generalActions";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

store.dispatch(authCheck());
store.dispatch(adminauthCheck());
if (window.performance) {
  store.dispatch(stopLoader());
}

ReactDOM.render(
  <Provider store={store}>
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <Router>
        <App />
        <ReduxToastr
          timeOut={4000}
          newestOnTop={true}
          preventDuplicates
          position="top-right"
          getState={(state) => state.toastr} // This is the default
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
        />
      </Router>
    </GoogleReCaptchaProvider>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
